import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = '页面未找到 - 奇妙漫画网';
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6 font-heading">页面未找到</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500">抱歉，该页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}